import type { PreviewElementChildrenRendererProps } from './types';

const usePresenter = (props: PreviewElementChildrenRendererProps): PreviewElementChildrenRendererProps => {
  return props;
};

export default usePresenter;
